@if (model) {
<!-- content -->
<div class="center p-t-6 p-b p-t-4-m p-t-4-s p-b-2-s">
    <div class="p-l-10 p-l-4-m p-l-4-s">
        <breadcrumbs [variant]="'light'">
        </breadcrumbs>
    </div>
    @if(backToRootUrl) {
    <div class="flex flex-justify-center m-t">
        <a class="flex flex-middle"
           [routerLink]="backToRootUrl">
            <i class="icon-chevron-left m-r-1 flex flex-middle"></i>
            <p class="p2">{{'Back to all articles' | translate}}</p>
        </a>
    </div>
    }

    <!-- tags -->
    @for (tagCategory of tagCategories; track tagCategory; let isFirst = $first) {
    <a class="inline-block bg-col-6 col-w p2 m-t-5 m-t-4-m m-t-4-s m-b p-a-1 p-l-2 p-r-2 b-radius-4"
       [class.m-l-1]="!isFirst"
       [routerLink]="tagCategory.data?.url || ''">{{tagCategory.data?.name || ''}}</a>
    }
    <!-- title -->
    @if (name) {
    <h1 class="h1 m-b-2 m-b-3-s">{{name}}</h1>
    }
    <!-- author -->
    @if (typeData.author) {
    <span class="p1">{{'Words by' | translate}}</span>
    <span class="p1"
          *iCms="'author' of typeData"></span>
    }
    <!-- date & reading time -->
    <div class="p2 m-t m-t-4-m m-b-4-s m-b m-b-4-m m-b-4-s flex flex-middle flex-justify-center">
        <p class="p2">{{typeData.date | date: 'MMMM dd, yyyy'}}</p>
        @if (typeData.date && typeData.readingTime) {
        <p>&nbsp;&#124;&nbsp;</p>
        }
        <p class="p2"
           *iCms="'readingTime' of typeData"></p>
        @if (typeData.readingTime) {
        <i class="icon-clock icon-medium m-l-1 inline-flex"></i>
        }
    </div>
    <!-- share -->
    <div class="m-b fs-6 lh-3 m-b-12 m-b-10-m m-b-10-s flex flex-middle flex-justify-center">
        <button class="m-l-2 cursor-pointer flex flex-middle"
                type="button"
                (click)="copyUrlToClipboard()"
                aria-label="CopyURL">
            <i class="icon-share inline-flex m-r-1"
               aria-hidden="true"></i>
            <p class="p2">{{'Share' | translate}}</p>
        </button>
    </div>
    <!-- component container -->
    <icms-outlet [components]="components"
                 [allow]="['image', 'cms-blog-component-more-stories', 'blog-text', 'blog-image-copy', 'blog-more-to-explore']"></icms-outlet>
</div>
}
